module.exports = __webpack_public_path__ + "img/meal-input-kr.f29ea083.png";